import { useEffect, useRef } from 'react';
import type { CircleFormState } from '../studio/circle/CircleFieldInput';
import { publishStudioOrder, type StudioOrderSnapshot } from '../studio/studio-job-bridge';
/** Знак хранит только owner/order/app, а восстановление проверяет существующий заказ GET. */
export function usePhotoJob(state: CircleFormState, kind: StudioOrderSnapshot['kind'] = 'photo') {
  const last = useRef<StudioOrderSnapshot | null>(null);
  const owner = state.intent?.owner,
    appId = state.form?.app_id ?? state.intent?.body.app_id,
    id = state.orderId,
    status = state.order?.status;
  useEffect(() => {
    if (owner && appId && id && status) {
      last.current = { owner, appId, orderId: id, status, kind, shown: true };
      publishStudioOrder(last.current);
    }
  }, [owner, appId, id, status, kind]);
  useEffect(() => {
    const clear = (event: Event) => {
      if ((event as CustomEvent).detail?.id === last.current?.orderId) last.current = null;
    };
    document.addEventListener('steos:studio:order-clear', clear);
    return () => {
      document.removeEventListener('steos:studio:order-clear', clear);
      if (last.current) publishStudioOrder({ ...last.current, shown: false });
    };
  }, []);
}
